import PreferenceLevel from "./PreferenceLevel";
import { useTranslation } from 'react-i18next';

const products = [

    { key: "beef", label: "Ternera" },
    { key: "lamb", label: "Cordero" },
    { key: "veal", label: "Carne de ternera joven" },
    { key: "chicken", label: "Pollo" },
    { key: "lowFat", label: "Comida baja en grasa" },
    { key: "fish", label: "Pescado" },
    { key: "prawns", label: "Gambas / Langostinos" },
    { key: "seafood", label: "Marisco" },
    { key: "salads", label: "Ensaladas" },
    { key: "vegetables", label: "Verduras" },
    { key: "fruit", label: "Fruta fresca" },
    { key: "desserts", label: "Postres" },
    { key: "barbecue", label: "Parrilladas al carbón" },
    { key: "stews", label: "Guisos y salteados" }

];

export default function FoodSection({
    food,
    onCuisineChange,
    onCuisineTypeChange,
    onProductChange,
    onCommentsChange,
    onDinnerChange,
    lang
}) {

    const { t } = useTranslation();

    return (

        <>
            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Alimentación")}</h2>
            <p className="u-align-center fontmontserrat" style={{ marginLeft: "20px" }}>{t("La gastronomía es una parte importante de cualquier viaje. Este es un viaje totalmente personalizado, diseñado en función de los gustos y preferencias de su grupo.")}</p>
            <h3 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Tipo de cocina que prefieren")}</h3>

            <div className="u-form-group u-form-name">
                <label htmlFor="mediterranea" className="u-label fontmontserrat">{t("Mediterránea")}</label>
                <input
                    id="mediterranea"
                    type="radio"
                    name="cocina"
                    checked={food.cuisine === "Mediterránea"}
                    onChange={() => onCuisineChange("Mediterránea")}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                    style={{ width: "30px", display: "initial" }}
                />
            </div>

            <div className="u-form-group u-form-name">
                <label htmlFor="europea" className="u-label fontmontserrat">{t("Europea")}</label>
                <input
                    id="europea"
                    type="radio"
                    name="cocina"
                    checked={food.cuisine === "Europea"}
                    onChange={() => onCuisineChange("Europea")}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                    style={{ width: "30px", display: "initial" }}
                />

            </div>

            <div className="u-form-group u-form-name">
                <label htmlFor="oriente" className="u-label fontmontserrat">{t("Oriente Medio")}</label>
                <input
                    id="oriente"
                    type="radio"
                    name="cocina"
                    checked={food.cuisine === "Oriente Medio"}
                    onChange={() => onCuisineChange("Oriente Medio")}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                    style={{ width: "30px", display: "initial" }}
                />
            </div>

            <div className="u-form-group u-form-name">
                <label htmlFor="otra" className="u-label fontmontserrat">{t("Otra")}</label>
                <input
                    id="otra"
                    type="radio"
                    name="cocina"
                    checked={food.cuisine === "Otra"}
                    onChange={() => onCuisineChange("Otra")}
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                    style={{ width: "30px", display: "initial" }}
                />
            </div>

            {food.cuisine === "Otra" && (
                <div className="u-form-group u-form-name u-label-none">
                    <label htmlFor="cualcocina" className="u-form-control-hidden u-label fontmontserrat">{t("Indique cuál")}</label>
                    <input
                        type="text"
                        placeholder={t("Indique cuál")}
                        id="cualcocina"
                        name="cualcocina"
                        value={food.otherCuisine}
                        onChange={(e) =>
                            onCuisineTypeChange(e.target.value)
                        }
                        required
                        className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                    />
                </div>
            )}

            <table className="preferences-table t-align-center" style={{ marginLeft: "auto", marginRight: "auto", width: "85%" }}>

                <thead>

                    <tr>

                        <th className="u-align-center fontmontserrat" style={{ width: "60%" }}>{t("Producto")}</th>
                        <th className="u-align-center fontmontserrat" style={{ width: "10%" }}>{t("Bajo")}</th>
                        <th className="u-align-center fontmontserrat" style={{ width: "10%" }}>{t("Medio")}</th>
                        <th className="u-align-center fontmontserrat" style={{ width: "10%" }}>{t("Alto")}</th>

                    </tr>

                </thead>

                <tbody>

                    {products.map(product => (

                        <PreferenceLevel
                            key={product.key}
                            label={product.label}
                            value={food.products[product.key]}
                            onChange={(value) =>
                                onProductChange(product.key, value)
                            }
                        />

                    ))}

                </tbody>

            </table>

            <div className="u-form-group u-form-name u-label-none">
                <label htmlFor="comentariosadicionales" className="u-form-control-hidden u-label fontmontserrat">{t("Comentarios adicionales")}</label>
                <textarea
                    rows="4"
                    value={food.comments}
                    placeholder={t("Comentarios adicionales")}
                    onChange={(e) =>
                        onCommentsChange(e.target.value)
                    }
                    required
                    id="comentariosadicionales"
                    name="comentariosadicionales"
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />
            </div>

            <h3 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Cenas")}</h3>
            <p className="u-align-center fontmontserrat" style={{ marginLeft: "auto", marginRight: "auto" }}>{t("En caso de no haber contratado pensión completa:")}</p>

            <div className="u-form-group u-form-name">
                <label htmlFor="dinneronBoard" className="u-label fontmontserrat">{t("Nos gustaría cenar a bordo en algunas ocasiones")}</label>
                <input
                    id="dinneronBoard"
                    type="checkbox"
                    name="dinneronBoard"
                    checked={food.dinner.onBoard}
                    onChange={(e) =>
                        onDinnerChange("onBoard", e.target.checked)
                    }

                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                    style={{ width: "30px", display: "initial" }}
                />
            </div>

            <div className="u-form-group u-form-nam">
                <label htmlFor="dinneronBoard" className="u-label fontmontserrat">{t("Tenemos previsto cenar en tierra algunas veces")}</label>
                <input
                    id="dinneronShore"
                    type="checkbox"
                    name="dinneronShore"
                    checked={food.dinner.onShore}
                    onChange={(e) =>
                        onDinnerChange("onShore", e.target.checked)
                    }

                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                    style={{ width: "30px", display: "initial" }}
                />
            </div>
        </>

    );

}
